import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Zone } from 'src/app/admin/models/zone.model';
import { RodjendanskezoneService } from 'src/app/admin/services/rodjendanskezone.service';

@Component({
  selector: 'app-delete-zone-modal',
  templateUrl: './delete-zone-modal.component.html',
  styleUrls: ['./delete-zone-modal.component.scss'],
})

export class DeleteZoneModalComponent  implements OnInit {
zone:Zone
  zoneNameQuery: string = '';
  maxAdultNumberQueryMin: string = '';
  maxChildNumbereQueryMin: string = ''
  maxAdultNumberQueryMax: string = ''
  maxChildNumbereQueryMax: string = ''

  roomnameQuery: string = ''
  currentPage: number = 1;
  itemsPerPage: number = 10
  messageError:string=''
  errMsg: string = '';
  constructor(private modalController: ModalController,  private rodjendanskezoneservice: RodjendanskezoneService) { }

  ngOnInit() {}
removeZone() {
   console.log('ZONE' , this.zone)
  
  this.rodjendanskezoneservice.deleteZone(this.zone.id).subscribe(res => {
       this.rodjendanskezoneservice.getAllZone({
          currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
          ZoneNameQuery: this.zoneNameQuery, MaxChildNumbereQueryMin: this.maxChildNumbereQueryMin, MaxChildNumbereQueryMax: this.maxChildNumbereQueryMax
          , MaxAdultNumberQueryMin: this.maxAdultNumberQueryMin, MaxAdultNumberQueryMax: this.maxAdultNumberQueryMax, RoomNameQuery: this.roomnameQuery
        })
      this.dismissModal();
    },(err) => {
    
     if (err.error.errors.includes('BirthayZone is referenced')) {
          this.messageError = 'Greška: Rođendanska  zona je rezervisana - nemoguće brisanje';
        }
        this.errMsg = this.messageError
      
    })
  }

  dismissModal() {
    this.modalController.dismiss();
  }





}
